import React from 'react';

import ModalNew from '../../components/ModalNew';
import Button, {ButtonTypes, ButtonSizes} from '../../components/ButtonNew';
import {Badge, BadgeColors} from '../../components/Badge';
import {useAnalytics} from '../../hooks';
import {getPersonaCallHref} from '../../util';
import WaveformIcon from './WaveformIcon';

export default function PersonaModal({
  isOpen, onClose, userUuid, interviewId,
}) {
  const {tracker} = useAnalytics();
  const personaHref = getPersonaCallHref({
    src: 'contribute_overview_skip', uuid: userUuid, interviewId,
  });

  return (
    <ModalNew isOpen={isOpen} onClose={onClose} modalClassName="max-w-md">
      <div className="flex flex-col px-4 pt-2">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-2xl font-medium text-gray-800 tracking-tight">
            Skip the review time
          </h2>
          <Badge color={BadgeColors.GRAY}>10 min</Badge>
        </div>
        <p className="text-gray-500 text-sm mb-4">
          Get instant trial access to our interview experiences database when you
          chat with our AI interviewer. Responses are anonymized.
        </p>

        <Button
          buttonType={ButtonTypes.SKEUOMORPHIC}
          size={ButtonSizes.LARGE}
          href={personaHref}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
          onClick={() => tracker.contributeClickPersonaSkipCta()}
        >
          <WaveformIcon />
          <span className="ml-2">Chat with AI interviewer</span>
        </Button>

        <Button
          buttonType={ButtonTypes.TERTIARY}
          size={ButtonSizes.LARGE}
          onClick={onClose}
          className="w-full mt-2 text-gray-600"
        >
          Continue filling out the form
        </Button>
      </div>
    </ModalNew>
  );
}
